export default function (name = '', app) {
  if (!window || !window._tfa) return

  const site = app.$store.state.siteBrand
  if (site !== 'flightgorilla') return

  const tfa = window._tfa
  const id = app.$config.TABOOLA_PIXEL_ID
  const event = 'event'

  tfa.push({ event, name, id })
}
